import { gql } from '@apollo/client';

import { NOTE_FIELDS } from 'app/src/components/Notes/queries';

const ERRORS = `errors { path, message }`;

const SYSTEM_ALERT_FIELDS = gql`
  ${NOTE_FIELDS}
  fragment SystemAlertFields on SystemAlert {
    id
    message
    alert
    createdAt
    dismissedAt
    __loadedAt
    alertDocumentation {
      name
      path
      documentation
    }
    dataCheckDocumentation {
      name
      documentation
    }
    linkPaths
    notes {
      ...NoteFields
    }
  }
`;

export const SYSTEM_ALERTS = gql`
  ${SYSTEM_ALERT_FIELDS}
  query SystemAlerts (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    systemAlerts (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...SystemAlertFields
        }
      }
      totalCount
    }
  }
`;

export const UPDATE_SYSTEM_ALERT_DISMISSED = gql`
  ${SYSTEM_ALERT_FIELDS}
  mutation UpdateSystemAlertDismissed (
    $id: ID!
    $dismissed: Boolean!
  ) {
    updateSystemAlertDismissed (
      id: $id
      dismissed: $dismissed
    ) {
      systemAlert {
        ...SystemAlertFields
      }
      ${ERRORS}
    }
  }
`;

export const DISMISS_SYSTEM_ALERT_NOTICES = gql`
  mutation DismissSystemAlertNotices (
    $maxCreatedAt: ISO8601DateTime!
  ) {
    dismissSystemAlertNotices (
      maxCreatedAt: $maxCreatedAt
    ) {
      ${ERRORS}
    }
  }
`;
